"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "m12 6-2-2H2v16h20V6zm2 10H6v-2h8zm4-4H6v-2h12z"
}), 'TopicSharp');